import React from 'react';

export default function InfoPage() {
  return (
    <div>
      <h2>Jak to działa?</h2>
      <p>
        System stref NXT pozwala na śledzenie, która organizacja kontroluje daną strefę na serwerze. Przejęcia stref są rejestrowane automatycznie, a ranking organizacji aktualizuje się na bieżąco na podstawie aktywności z ostatniego tygodnia.
      </p>
      <ul>
        <li>Każda strefa może być przejęta przez organizację podczas rozgrywki.</li>
        <li>Ostatnie przejęcia pokazują historię zmian właścicieli stref.</li>
        <li>Liderzy wpływów to ranking organizacji z największą liczbą punktów za kontrolę stref.</li>
        <li>Wszystkie dane są aktualizowane automatycznie na podstawie aktywności graczy.</li>
        <li style={{color: '#e43c92', fontWeight: 600}}>Punkty będą resetowane co miesiąc, a zdobyte punkty będzie można wydawać w dark shopie na różne przedmioty na serwerze!</li>
        <li><b>Przejęcie strefy</b> wymaga obecności minimum 5 aktywnych osób z organizacji, która ją posiada <b>(poza godzinami 16:00-23:00)</b>.</li>
        <li><b>Między 16:00 a 23:00</b> każdy może przejąć strefę bez tego wymogu.</li>
        <li><b>Punkty zdobywane między 16:00 a 23:00 liczą się 6x szybciej!</b></li>
        <li>Strefy zarabiają co godzinę niewielką ilość gotówki dla organizacji.</li>
        <li><b>Główną nagrodą są punkty</b> – to one decydują o pozycji w rankingu i możliwościach w dark shopie.</li>
        <li style={{color: '#e43c92', fontWeight: 600}}>Jeśli organizacja posiada więcej niż 1 strefę, to każda z tych stref może być przejęta o dowolnej godzinie dnia i nocy, niezależnie od tego, czy broniący są aktywni.</li>
        <li><b>Strefę może atakować i bronić maksymalnie 6 osób.</b></li>
      </ul>
      <p style={{marginTop: 24, color: '#e43c92', fontWeight: 600}}>
        Masz pytania? Skontaktuj się z administracją serwera NXT!
      </p>
    </div>
  );
} 